import { render, staticRenderFns } from "./superuser-gift-card-details.vue?vue&type=template&id=776e8195&"
import script from "./superuser-gift-card-details.vue?vue&type=script&lang=js&"
export * from "./superuser-gift-card-details.vue?vue&type=script&lang=js&"
import style0 from "./superuser-gift-card-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports